export const formatDataforGenericSelect = (data) => {

    //console.log('data format req: ', data)
    let options;
    if (data) {
        options = data.map((i) => {

            let description = i.name ?? i.description ?? i.prefix
            if (i.name && i.description.length > 0) {
                //console.log('description: ', description)
                //👉 si existe name pero con prop .length > 0
                return {
                    value: `${i.id}`,
                    label: `${i.name} (${i.description})`,
                }
            }

            else {
                return {
                    value: i.id,
                    label: description
                }
            }
        })
    }

    //console.log('new array options: ', options)
    return options
}